<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="h3 col-12 d-block d-md-none">{{text}}</div>
      <div class="col-7 m-0 custom-text-align px-0">
        <span class="h1 d-none d-md-block" v-if="text != ''" style="float:left;">{{text}}</span>
        <div style="display:inline-table;">
          <a href="#" class="btn btn-link px-0" style="color:initial;margin-bottom:3px;" @click="stepPrevious()"><i class="icon-arrow-left22"></i></a>
          {{datelabel}}
          <a href="#" class="btn btn-link px-0" style="color: initial; margin-bottom: 3px;" @click="stepNext()"><i class="icon-arrow-right22"></a>
        </div>
      </div>
      <div class="col-5 m-0 text-right px-0">
        <a href="#" class="btn btn-link btn-light  px-1" @click="selectMode('day')">{{$t('day')}}</a>
        <a href="#" class="btn btn-link btn-light px-1" @click="selectMode('week')">{{$t('week')}}</a>
        <a href="#" class="btn btn-link btn-light px-1" @click="selectMode('month')">{{$t('month')}}</a>
        <a href="#" class="btn btn-link btn-light px-1" @click="selectMode('year')">{{$t('year')}}</a>
      </div>
    </div>   
  </div>
</template>

<script>

  import moment from 'moment'

  export default {
    name: 'input-date-navigation',
    components: {
    },
    data() {
      return {
        datelabel: 'date',
        startDate: null,
        endDate: null,
        selectedMode: 'month',
        mom: null,
      }
    },
    props: {
      multiplerowclick: {
        required: false,
        type: String,
        default: ''
      },
      text: {
        required: false,
        type: String,
        default: ''
      },
    },
    methods: {
      selectMode(mode) {
        this.selectedMode = mode;
        if (this.selectedMode == 'day') {
          this.endDate = this.$store.getMomentLocale(this.startDate).add(1, 'days')
          //this.endDate = this.startDate.add(1, 'days');
        }
        else if (this.selectedMode == 'week') {
          this.startDate = this.startDate.startOf('week');
          this.endDate = this.$store.getMomentLocale(this.startDate).endOf('week');
          //this.endDate = this.endDate.endOf('week');
        }
        else if (this.selectedMode == 'month') {
          this.startDate = this.startDate.startOf('month');
          this.endDate = this.$store.getMomentLocale(this.startDate).endOf('month');
          //this.endDate = this.endDate.endOf('month');
        }
        else if (this.selectedMode == 'year') {
          this.startDate = this.startDate.startOf('year');
          this.endDate = this.$store.getMomentLocale(this.startDate).endOf('year');
          //this.endDate = this.endDate.endOf('month');
        }
        
        this.renderLabel();
        this.$emit("changed", this.startDate, this.endDate)
      },
      stepPrevious() {
        if (this.selectedMode == 'day') {
          this.startDate = this.startDate.subtract(1, 'days');
          this.endDate = this.$store.getMomentLocale(this.startDate).add(1, 'days');
        }
        else if (this.selectedMode == 'week') {
          this.startDate = this.startDate.subtract(1, 'weeks').startOf('week');
          this.endDate = this.$store.getMomentLocale(this.startDate).endOf('week');
          //this.endDate = this.endDate.subtract(1, 'weeks').endOf('week');
        }
        else if (this.selectedMode == 'month') {
          this.startDate = this.startDate.subtract(1, 'months').startOf('month');
          this.endDate = this.$store.getMomentLocale(this.startDate).endOf('month');
          //this.endDate = this.endDate.subtract(1, 'months').endOf('month');
        }
        else if (this.selectedMode == 'year') {
          this.startDate = this.startDate.subtract(1, 'year').startOf('year');
          this.endDate = this.$store.getMomentLocale(this.startDate).endOf('year');
          //this.endDate = this.endDate.subtract(1, 'months').endOf('month');
        }
        this.renderLabel();
        this.$emit("changed", this.startDate, this.endDate)
      },
      stepNext() {
        if (this.selectedMode == 'day') {
          this.startDate = this.startDate.add(1, 'days');
          this.endDate = this.$store.getMomentLocale(this.endDate).add(1, 'days');
        }
        else if (this.selectedMode == 'week') {
          this.startDate = this.startDate.add(1, 'weeks').startOf('week');
          this.endDate = this.$store.getMomentLocale(this.endDate).endOf('week');
        }
        else if (this.selectedMode == 'month') {
          this.startDate = this.startDate.add(1, 'months').startOf('month');
          this.endDate = this.$store.getMomentLocale(this.startDate).endOf('month');
        }
        else if (this.selectedMode == 'year') {
          this.startDate = this.startDate.add(1, 'year').startOf('year');
          this.endDate = this.$store.getMomentLocale(this.startDate).endOf('year');
        }
        this.renderLabel();
        this.$emit("changed", this.startDate, this.endDate, this.selectedMode)
      },
      renderLabel() {
        if (this.selectedMode == 'day') {
          //this.datelabel = this.startDate.format('D') + " " + this.startDate.format('MMM')
          this.datelabel = this.startDate.format('D') + " " + this.startDate.format('MMM') + " " + this.startDate.format('YYYY') + " - " + this.endDate.format('D') + " " + this.endDate.format('MMM') + " " + this.endDate.format('YYYY');
        }
        else if (this.selectedMode == 'week') {
          this.datelabel = this.startDate.format('D') + " " + this.startDate.format('MMM') + " " + this.startDate.format('YYYY') + " - " + this.endDate.format('D') + " " + this.endDate.format('MMM') + " " + this.endDate.format('YYYY');
        }
        else if (this.selectedMode == 'month') {
          this.datelabel = this.startDate.format('D') + " " + this.startDate.format('MMM') + " " + this.startDate.format('YYYY') + " - " + this.endDate.format('D') + " " + this.endDate.format('MMM') + " " + this.endDate.format('YYYY');
        }
        else if (this.selectedMode == 'year') {
          this.datelabel = this.startDate.format('D') + " " + this.startDate.format('MMM') + " " + this.startDate.format('YYYY') + " - " + this.endDate.format('D') + " " + this.endDate.format('MMM') + " " + this.endDate.format('YYYY');
        }
      },
      getDate() {
        return {
          startDate: this.startDate,
          endDate: this.endDate
        }
      },
    },
    
    created() {
     
      this.startDate = this.$store.getMomentLocale(new Date()).startOf('month');
      this.endDate = this.$store.getMomentLocale(new Date()).endOf('month');
    },
    mounted() {      
      this.renderLabel();
    },

    watch: {
      something: function (newVal, oldVal) {
        
      },
    }
  }
</script>

<style scoped>

  .custom-text-align {
    text-align: right !important;
  }

  @media (max-width: 767px) {
    .custom-text-align {
      text-align: left !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form-components/input-date-navigation.vue